import { UserTicketsModel } from '../../types/loginTypes';

export interface DiscountTradingPackage {
  id: number;
  image: string;
  price: number;
  maxDeposit: number;
  doubleTradingBinary: number;
  membershipBenefits: string[];
  extraTools: string[];
}

export interface DiscountCode {
  id: number;
  name: string;
  discountPercentage: number;
  price: number;
  package: DiscountTradingPackage;
}

export interface GetDiscountCodesResponse {
  discountCodes: DiscountCode[];
}

export interface UnilevelUsers {
  id: number;
  referrerId: number;
  username: string;
  profileImageUrl: string;
}

export interface GetSearchedUnilevelUsersResponse {
  users: UnilevelUsers[];
}

export interface UserDiscountCode {
  id: number;
  discountCodeId: number;
  buyerUserId: number;
  receiverUserId: number;
  dateCreated: string;
  datePaid: string;
  price: number;
}

export interface BuyDiscountCodeResponse {
  userDiscountCode: UserDiscountCode;
  userTickets: UserTicketsModel;
}

export enum BuyDiscountCodeSteps {
  BUY = 1,
  SUCCESS
}
